import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { AuthService } from './services/auth.service';
import { loginComRetorno } from './auth.guard';

/**
 * Restringe a rota a perfis específicos, informados em `data.perfis`.
 *
 * Complementa o `permissaoGuard`: perfis com acesso irrestrito ao próprio escopo
 * (rh_admin e cliente_admin) recebem todas as chaves do catálogo, então uma chave
 * de permissão não distingue a RH Autentic de um administrador de Cliente. Telas
 * que só a RH Autentic pode operar precisam checar o perfil.
 */
export const perfilGuard: CanMatchFn = (route: Route, _segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const perfis = normalizarPerfis(route.data?.['perfis']);

  if (perfis.length === 0) return true;

  return sessaoCarregada(auth).pipe(
    map((logado) => {
      if (!logado) return loginComRetorno(router);

      const perfil = auth.usuario?.perfil;

      return (!!perfil && perfis.includes(perfil)) || router.createUrlTree(['/sem-acesso']);
    }),
  );
};

function sessaoCarregada(auth: AuthService): Observable<boolean> {
  return auth.usuario ? of(true) : auth.verificarSessao();
}

function normalizarPerfis(valor: unknown): string[] {
  if (typeof valor === 'string') return [valor];
  if (Array.isArray(valor)) return valor.filter((p): p is string => typeof p === 'string');

  return [];
}
